export default __webpack_public_path__ + "static/media/icon_zendesk-support.6f3c91e3.svg";